// Libs
import { Box, Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { useEffect, useCallback, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Components, Layouts, Pages
import { Loading } from '~/components/common';

// Others
import { MESSAGE_QUICK_BOOK_CONNECTED } from '~/utils/constants/common';
import axiosClient from '~/apis/axiosClient';

// Styles, images, icons
import styles from './QuickBookCallBack.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const QuickBookCallBack = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const [searchParams] = useSearchParams();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //#endregion Declare State

  //#region Implement Hook
  const handleCallBack = useCallback(async () => {
    setIsLoading(true);
    try {
      // Forward the OAuth callback params to backend for token exchange
      const queryString = searchParams.toString();
      await axiosClient.get(`quick-books/call-back?${queryString}`);

      if (window.opener) {
        window.opener.postMessage(MESSAGE_QUICK_BOOK_CONNECTED, '*');
      }
      window.close();
    } catch (error) {
      // Even on error, notify parent and close
      if (window.opener) {
        window.opener.postMessage(MESSAGE_QUICK_BOOK_CONNECTED, '*');
      }
      window.close();
    } finally {
      setIsLoading(false);
    }
  }, [searchParams]);

  useEffect(() => {
    handleCallBack();
  }, [handleCallBack]);
  //#endregion Implement Hook

  //#region Handle Function

  return (
    <Box component={'div'} className={cx('container')}>
      <Typography component='p' variant='body1'>
        {isLoading && <Loading />}
      </Typography>
    </Box>
  );
};

export default QuickBookCallBack;
